exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._31Qe7OeytrUVVo{padding:12px 17px;margin-bottom:16px;background:#f4f5f7;border-radius:3px}._2fQWcZHs0rQTQm{display:flex;flex-direction:row;justify-content:space-between}._2fQWcZHs0rQTQm p{color:#5e6c84}.eB6-1k_YWwt4Cs{width:32px;height:32px;padding-left:9px;transition:background .2s ease;background:#f4f5f7}.eB6-1k_YWwt4Cs:hover{background:#dfe1e6}.d5yWkXVJpCh_qS{display:flex;flex-direction:row}._3ypXQd3WXKWKZ4{margin-right:12px}._1LgYglXIm2-fcE{text-transform:capitalize}", ""]);

// exports
exports.locals = {
	"teamTemplatePicker": "_31Qe7OeytrUVVo",
	"teamTemplatePickerHeader": "_2fQWcZHs0rQTQm",
	"teamTemplatePickerDismiss": "eB6-1k_YWwt4Cs",
	"teamTemplatePickerTemplates": "d5yWkXVJpCh_qS",
	"teamTemplatePickerTemplatesTemplate": "_3ypXQd3WXKWKZ4",
	"teamTemplatePickerTeamType": "_1LgYglXIm2-fcE"
};